<script setup>
import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useUsuarioStore } from "@/store/usuarioStore";

const usuarioStore = useUsuarioStore();
const route = useRoute();
const router = useRouter();

const pendingId = computed(() => route.query.id || null);
const token = computed(() => route.query.token || null) ;
const errores = computed(() => usuarioStore.errores || []) ;

const loading = ref(false);

async function confirmar() {
  loading.value = true;
  usuarioStore.confirmarRegistro(pendingId.value, token.value)
  loading.value = false;
}

function irAlRegistro() {
  router.push({ path: "/registro" });
}

function irAlLogin() {
  router.push({ path: "/login" });
}


onMounted(() => {
  confirmar();
});
</script>

<template>
  <div class="container py-5" style="max-width: 720px;">
    <div class="card shadow-sm border-0">
      <div class="card-body p-4 p-md-5">
        <h1 class="h4 fw-bold mb-2">Confirmación de registro</h1>

        <p class="text-muted mb-4">
          Estamos validando tu registro. Si todo está OK, te redirigimos automáticamente.
        </p>

        <div v-if="loading" class="d-flex align-items-center gap-2">
          <div class="spinner-border" role="status" aria-hidden="true"></div>
          <span>Confirmando...</span>
        </div>

        <div v-if = 'errores.length > 0' class="alert alert-danger">
          <div class="fw-bold mb-1">No pudimos confirmar tu registro</div>
          <div v-for="(error, i) in errores" v-bind:key="i">{{ errores }}</div>

          <div class="mt-3 d-flex flex-wrap gap-2">
            <button class="btn btn-primary" @click="irAlRegistro">
              Volver al registro
            </button>
            <button class="btn btn-outline-secondary" @click="irAlLogin">
              Ir al login
            </button>
          </div>
        </div>

        <div class="mt-4 small text-muted">
          Si el enlace expiró (24h) o ya fue usado, tenés que solicitar uno nuevo desde la pantalla de registro.
        </div>
      </div>
    </div>
  </div>
</template>
